export default {
  title: 'Istoricul editărilor meniului',
  subtitle: 'Vedeți cine a modificat prețurile, disponibilitatea și vizibilitatea pentru {{company}} — și când.',
  filters: {
    type: {
      label: 'Tip',
    },
    item: {
      placeholder: 'Toate elementele',
    },
    event: {
      label: 'Eveniment',
    },
  },
  columns: {
    when: 'Când',
    who: 'Modificat de',
    type: 'Tip',
    item: 'Element',
    event: 'Eveniment',
    changes: 'Modificări',
  },
  types: {
    product: 'Produs',
    modifier: 'Modificator',
    category: 'Categorie',
    modifier_group: 'Grup de modificatori',
    menu: 'Meniu',
  },
  events: {
    created: 'Creat',
    updated: 'Actualizat',
    deleted: 'Șters',
  },
  fields: {
    name: 'Nume',
    description: 'Descriere',
    price: 'Preț',
    is_available: 'Disponibilitate',
    is_visible: 'Vizibilitate',
    is_available_for_pickup: 'Disponibilitate ridicare',
    is_available_for_delivery: 'Disponibilitate livrare',
    tax_category_id: 'Categorie de taxe',
    schedule: 'Ore de afișare',
    is_required: 'Obligatoriu',
    max_count: 'Număr maxim de opțiuni',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Preț ridicare',
    delivery: 'Preț livrare',
    dine_in: 'Preț consum în local',
    room_service: 'Preț room service',
  },
  booleans: {
    on: 'Disponibil',
    off: 'Indisponibil',
    yes: 'Da',
    no: 'Nu',
  },
  schedule: {
    always: 'Întotdeauna',
    every_day: 'În fiecare zi',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Următor',
  },
  causers: {
    orders_terminal: 'Terminal comenzi',
    approved_by: {
      amigo: 'Amigo, aprobat de {{name}}',
      assistant: 'Asistent, aprobat de {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Deschide în jurnalul Amigo',
  system: 'Sistem',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Încărcarea istoricului editărilor meniului a eșuat',
  },
};
